import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes, taskKeys } from '@core/react-query/features/tasks/task'
import { LinkedProcesses } from '@core/entities/linkedProcesses'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const taskLinkedProcessTransform = (data: LinkedProcesses) => {
  return LinkedProcesses.new(data)
}

export const useGetTaskLinkedProcesses = (
  payload: RequestTypes['getTaskLinkedProcesses'],
  options?: UseQueryOptions<LinkedProcesses, RequestErrorType>,
) => {
  return useQuery({
    select: taskLinkedProcessTransform,
    ...taskKeys.byId(payload)._ctx.linkedProcesses,
    ...options,
  })
}
